<template lang="pug">
  #dashboard
    .container
        //- .box(:style="{ backgroundImage: 'url(' + getImgUrl('home-bg') + ')' }")
        .box-wrapper
          .box
            .row
              .column.left
                img(class="characters desktop", src="../assets/images/dashboard/angna.png")
              .column.right
                .greeting-box
                  p.greeting(:class="{ en: $LOCALE === 'en', th: $LOCALE === 'th', extended: extended === true }") Hej, {{ smaleName }}!
                  p.greeting.xs(:class="{ en: $LOCALE === 'en', th: $LOCALE === 'th', extended: extended === true }") {{ $LANG.dashboard.SMALISH_PASSPORT_NO }} <span class="red"> {{ smaleMembershipID }} </span>
                  p.greeting.title.desktop {{ $LANG.dashboard.WELCOME_TITLE }}
                  p.sub-greeting.desktop {{ $LANG.dashboard.WELCOME_SUBTITLE }}
                  p.greeting.mobile {{ $LANG.dashboard.WELCOME_TITLE }}
                    br
                    span.sub-greeting
                    img(class="alextampi mobile", src="../assets/images/dashboard/angna.png")
                  p.desc {{ $LANG.dashboard.WELCOME_SUBTITLE }}
                router-link(:to="`/${$LOCALE}/profile`" gtm-label="dashboard.profile")
                  img.btn-align(:class="{ en: $LOCALE === 'en', th: $LOCALE === 'th' }" :src="getImgUrl('btn-personal-info')" gtm-label="dashboard.profile")
                router-link(:to="`/${$LOCALE}/account-balance`" gtm-label="dashboard.account-balance")
                  img.btn-align(:class="{ en: $LOCALE === 'en', th: $LOCALE === 'th' }" :src="getImgUrl('btn-account-balance')" gtm-label="dashboard.account-balance")
                router-link(:to="`/${$LOCALE}/green-credit`" gtm-label="dashboard.green-credit")
                  img.btn-align(:class="{ en: $LOCALE === 'en', th: $LOCALE === 'th' }" :src="getImgUrl('btn-green')" gtm-label="dashboard.green-credit")
                .item
                  a(href="javascript:void" @click="logout" gtm-label="dashboard.logout")
                    img(class="btn-logout", :src="getImgUrlBase('btn-logout')" gtm-label="dashboard.logout")
          img.thampi-hand(src="../assets/images/dashboard/thampi-hand.png")
</template>

<style lang="sass" scoped>
  @import "../sass/variables"

  #dashboard
    .container
      +mobile
        padding-left: 0
        padding-right: 0
    .row::after
      content: ""
      display: table
      clear: both

    .column
      float: left

    .left
      position: relative
      width: 30%
      @media #{$mobile}
        display: none

    .right
      padding-left: 20px
      padding-right: 20px
      width: 70%
      @media #{$mobile}
        padding: 0
        width: 100%
      .greeting-box
        width: 100%
        float: right
        background-image: url('../assets/images/dashboard/bubble.png')
        background-repeat: no-repeat
        margin: 10px 0
        +desktop
          transform: translateX(12%)
        @media #{$mobile}
          background-image: none
          text-align: center
    .box-wrapper
      position: relative
      width: 90%
      margin: auto
      max-width: 650px
      .box
        position: relative
        background-size: 100%
        // margin: 0 auto
        // padding: 50px 140px 20px 45px
        // width: 100%
        min-height: 310px
        height: 100%
        display: flex
        -webkit-box-orient: vertical
        -webkit-box-direction: normal
        -webkit-flex-direction: column
        -ms-flex-direction: column
        flex-direction: column
        min-height: 40px
        margin: 0 auto 32px
        padding: 5px
        // max-width: 650px
        height: auto
        border-radius: 14px
        -webkit-box-shadow: 0 0 25px #9ecaed
        box-shadow: 0 0 25px #9ecaed
        background-color: #ffffff
        padding-bottom: 10px
        z-index: 1
        @media #{$mobile}
          padding: 20px
          background: transparent
          box-shadow: none
          border-radius: 0
          margin: 0 auto
          width: 100%
          box-shadow: 0 0


      .thampi-hand
        width: 150px
        position: absolute
        z-index: 0
        right: 0
        top: 50%
        transform: translate(80%, -50%)
        @media #{$mobile}
          display: none

    .characters
      position: relative
      width: 100%
      left: 20%
      margin-top: 20%
      @media #{$mobile}
        display: none

    .photo-frame
      width: 100%
      position: relative
      top: 0
      left: 0
      @media #{$mobile}
        display: none

    .photo
      max-width: 145px
      position: absolute
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)
      @media #{$mobile}
        display: none

    .greeting
      font-size: 1.13em
      color: $red
      margin-top: 15px
      margin-left: 20px
      margin-bottom: 0
      // padding-bottom: 45px
      &.extended
        +desktop
          margin-top: 8px
          font-size: 16px
          // padding-bottom: 34px
          // padding-right: 20px
      +desktop
        // margin-left: 55px
      &.xs
        margin-left: 20px
        margin-top: 5px
        margin-bottom: 10px
        padding-top: 0
        color: #555555
        font-size: 13px
        span.red
          color: $red
      &.title
        margin: 0 0 0 20px
        font-weight: bold
      @media #{$mobile}
        margin-top: 0
        margin-left: 0
        padding-bottom: 0
        margin-bottom: 10px
        text-align: center

    .sub-greeting
      font-size: 13px
      margin-left: 20px
      margin-top: 0
      margin-bottom: 15px
      color: #555555
      @media #{$mobile}
        display: block
        font-size: 1.13em
        color: $red
    .desc
      display: none
      @media #{$mobile}
        display: block
        font-size: 14px
        color: $black
        text-align: center

    .btn-align
      float: right
      width: 90%
      @media #{$mobile}
        width: 100%
        display: block
        float: none
        margin: 0 auto

    .btn-logout
      float: right
      max-width: 100px
      @media #{$mobile}
        display: block
        float: none
        margin: 10px auto 0
        max-width: 150px

    .button-container
      text-align: center
      +mobile
        display: flex

    .item
      img
        +mobile
          width: 100%

    .alextampi
      display: none
      @media #{$mobile}
        display: initial
        max-width: 70%
        margin-top: 20px
</style>

<script>
  import api from '../library/api.js'

  export default {
    data () {
      return {
        smaleName: '',
        smaleMembershipID: '',
        extended: false
      }
    },

    created () {
      if (!window.localStorage.getItem('token')) {
        this.$router.push('/')
      }
    },

    mounted () {
      this.getProfile()
    },

    methods: {
      getImgUrl (pic) {
        return require('../assets/images/dashboard/' + pic + '-' + this.$LOCALE + '.png')
      },

      getImgUrlBase (pic) {
        return require('../assets/images/' + pic + '-' + this.$LOCALE + '.png')
      },

      getProfile () {
        api('GetProfile')
          .then(res => {
            res = JSON.parse(res)

            // let lastName = ''
            // if (res.lastName) {
            //   lastName = ' ' + res.lastName
            // }
            this.smaleName = res.firstName
            this.smaleMembershipID = res.membershipNumber
            if (this.smaleName.length > 19) {
              this.extended = true
            }
          })
          .catch(err => {
            if (err.status === 401 || err.status === 403) {
              window.localStorage.removeItem('token')
              this.$router.push('/' + this.$LOCALE )
            }
          })
      },

      logout () {
        api(`logout?token=${window.localStorage.getItem('token')}`)
        window.localStorage.removeItem('token')
        this.$router.push('/' + this.$LOCALE )
      }
    }
  }
</script>
